var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import DepartmentTree from '~/components/system-manage/department-tree.vue';
import { Prop, Emit } from 'vue-property-decorator';
import { Dependencies } from '~/core/decorator';
import { PageService } from '~/utils/page.service';
import { UserService } from '~/services/management-service/user.service';
import TelConfirmDistribution from '~/components/distribution-common/tel-confirm-distribution.vue';
import LegalConfirmDistribution from '~/components/distribution-common/legal-confirm-distribution.vue';
import VisitConfirmDistribution from '~/components/distribution-common/visit-confirm-distribution.vue';
import AssistVisitConfirmDistribution from '~/components/distribution-common/assist-visit-confirm-distribution.vue';
import AssistLawsuitConfirmDistribution from '~/components/distribution-common/assist-lawsuit-confirm-distribution.vue';
import AssistCaseConfirmDistribution from '~/components/distribution-common/assist-case-confirm-distribution.vue';
import { TelCaseManageService } from '~/services/domain-service/tel-case-manage.service';
var UserCaseAllot = /** @class */ (function (_super) {
    __extends(UserCaseAllot, _super);
    function UserCaseAllot() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.allotType = 1;
        _this.selectionList = [];
        _this.userDataSet = [];
        _this.currentDept = null;
        _this.nowNode = null;
        _this.distributionData = {};
        _this.submitLoading = false;
        _this.model = {
            state: 0,
            deptCode: '',
            caseSwitch: 'ENABLED'
        };
        _this.dialog = {
            TelConfirmDistribution: false,
            LegalConfirmDistribution: false,
            VisitConfirmDistribution: false,
            AssistVisitConfirmDistribution: false,
            AssisLawsuittVisitConfirmDistribution: false,
            AssisCaseConfirmDistribution: false,
        };
        _this.DepartmentData = null;
        _this.collectionType = '';
        return _this;
    }
    UserCaseAllot.prototype.refreshList = function () { };
    UserCaseAllot.prototype.cancle = function () {
        this.resetData();
    };
    Object.defineProperty(UserCaseAllot.prototype, "display", {
        get: function () {
            return this.allotType === 0 ? '' : this.selectionList;
        },
        set: function (v) {
            this.selectionList = v;
        },
        enumerable: false,
        configurable: true
    });
    UserCaseAllot.prototype.refresh = function (data, collectionType) {
        this.DepartmentData = data;
        this.collectionType = collectionType;
    };
    //下一步
    UserCaseAllot.prototype.next = function () {
        // 给子组件发送的数据
        this.distributionData = {
            selectedUser: this.selectionList,
            selectedCase: this.selectedCase,
        };
        switch (this.collectionType) {
            case 'TEL':
                this.dialog.TelConfirmDistribution = true;
                break;
            case 'LEGAL':
                this.dialog.LegalConfirmDistribution = true;
                break;
            case 'VISIT':
                this.dialog.VisitConfirmDistribution = true;
                break;
            case 'ASSIST_VISIT':
                this.dialog.AssistVisitConfirmDistribution = true;
                break;
            case 'LAW_STAY':
                this.dialog.AssisLawsuittVisitConfirmDistribution = true;
                break;
            case 'LAW_STAY_OUTSOURCE':
                this.dialog.AssisLawsuittVisitConfirmDistribution = true;
                break;
            case 'CHEAT_STAY':
                this.dialog.AssisLawsuittVisitConfirmDistribution = true;
                break;
            case 'CHEAT_SURVEY':
                this.dialog.AssisLawsuittVisitConfirmDistribution = true;
                break;
            case 'LAW_CASE':
                this.dialog.AssisCaseConfirmDistribution = true;
                break;
            default:
                break;
        }
    };
    //按机构分配
    UserCaseAllot.prototype.submit = function () {
        var _this = this;
        var model = {
            caseIds: this.selectedCase.map(function (v) { return v.id; }),
            commonFlag: 'YES',
            deptIds: [this.nowNode.id],
            distributeCategory: 'TO_DEPARTMENT',
        };
        this.submitLoading = true;
        this.telCaseManageService.confirmDistributeCase(model).subscribe(function (data) {
            _this.submitLoading = false;
            _this.$message.success('分配成功');
            _this.refreshList();
            _this.cancle();
        });
    };
    /**
     * 获取当前树选择项
     */
    UserCaseAllot.prototype.getCheckedNodes = function (item) {
        if (item.deptCode === this.model.deptCode) {
            return false;
        }
        this.model.deptCode = item.deptCode;
        this.nowNode = item;
        this.refreshData();
    };
    UserCaseAllot.prototype.refreshData = function () {
        var _this = this;
        this.userService
            .getAllUsers(this.model, this.pageService)
            .subscribe(function (data) {
            _this.userDataSet = data;
        });
    };
    /**
     * 重置数据
     */
    UserCaseAllot.prototype.resetData = function () {
        this.allotType = 1;
        this.currentDept = null;
        this.nowNode = null;
        this.userDataSet = [];
        this.model.deptCode = '';
        this.DepartmentData = null;
    };
    __decorate([
        Dependencies(PageService)
    ], UserCaseAllot.prototype, "pageService", void 0);
    __decorate([
        Dependencies(UserService)
    ], UserCaseAllot.prototype, "userService", void 0);
    __decorate([
        Dependencies(TelCaseManageService)
    ], UserCaseAllot.prototype, "telCaseManageService", void 0);
    __decorate([
        Prop({ default: false, type: Boolean })
    ], UserCaseAllot.prototype, "again", void 0);
    __decorate([
        Prop({ required: true })
    ], UserCaseAllot.prototype, "selectedCase", void 0);
    __decorate([
        Emit('refreshList')
    ], UserCaseAllot.prototype, "refreshList", null);
    __decorate([
        Emit('close')
    ], UserCaseAllot.prototype, "cancle", null);
    UserCaseAllot = __decorate([
        Component({
            components: {
                DepartmentTree: DepartmentTree,
                TelConfirmDistribution: TelConfirmDistribution,
                LegalConfirmDistribution: LegalConfirmDistribution,
                VisitConfirmDistribution: VisitConfirmDistribution,
                AssistVisitConfirmDistribution: AssistVisitConfirmDistribution,
                AssistLawsuitConfirmDistribution: AssistLawsuitConfirmDistribution,
                AssistCaseConfirmDistribution: AssistCaseConfirmDistribution,
            },
        })
    ], UserCaseAllot);
    return UserCaseAllot;
}(Vue));
export default UserCaseAllot;
